/**
 * statAnalysis 统计分析
 */

const App = () => import('@/module/index/layout/App.vue')
const disciplineManagement = () => import('@/module/disciplineManagement/disciplineManagement.vue')
const operationlog = () => import('@/module/operationlog/operationlog.vue')

export default {
  path: '/operationMgmt',
  component: App,
  meta: {
    title: '',
    requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
    isback: true
  },
  children: [{
    path: '/operationMgmt/disciplineManagement',
    component: disciplineManagement
  }, {
    path: '/operationMgmt/operationlog',
    component: operationlog
  }]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/operationlog.js